import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import { __decorate } from "tslib";
import { Component } from 'intact-vue';
import template from './table.vdt';
import { useColumns } from './useColumns';
import { useFixedColumns } from './useFixedColumns';
import { useStickyHeader } from './useStickyHeader';
import { bind } from '../utils';
import { useChecked } from './useChecked';
import { useDisableRow } from './useDisableRow';
import { useSortable } from './useSortable';
import { useMerge } from './useMerge';
import { useExpandable } from './useExpandable';
import { useSelected } from './useSelected';
import { useTree } from './useTree';
import { Tooltip } from '../tooltip/tooltip';
import { useResetRowStatus } from './useResetRowStatus';
import { exportTable as _exportTable } from './exportTable';
import { useResizable } from './useResizable';
import { useDraggable } from './useDraggable';
import { useStickyScrollbar } from './useStickyScrollbar';
import { useWidth } from './useWidth';
import { useScroll } from './useScroll';
import { usePagination } from './usePagination';
import { useConfigContext } from '../config';
var typeDefs = {
  data: Array,
  fixHeader: [Boolean, String, Number],
  stickHeader: [Boolean, String, Number],
  stickScrollbar: [Boolean, String, Number],
  checkType: ['checkbox', 'radio', 'none'],
  checkedKeys: Array,
  rowKey: Function,
  rowCheckable: Boolean,
  disableRow: Function,
  type: ['default', 'border', 'grid'],
  stripe: Boolean,
  rowClassName: Function,
  group: Object,
  sort: Object,
  loading: Boolean,
  merge: Function,
  expandedKeys: Array,
  rowExpandable: Boolean,
  selectedKeys: Array,
  rowSelectable: [Boolean, 'single', 'multiple'],
  childrenKey: String,
  indent: Number,
  spreadKeys: Array,
  tooltipPosition: Tooltip.typeDefs.position,
  tooltipContainer: Tooltip.typeDefs.container,
  keepStatus: Boolean,
  showIndeterminate: Boolean,
  resizable: Boolean,
  minColWidth: Number,
  widthStoreKey: String,
  draggable: Boolean,
  animation: [Boolean, Array],
  hideHeader: Boolean,
  pagination: [Boolean, Object]
};
var defaults = function defaults() {
  return {
    checkType: 'checkbox',
    rowKey: function rowKey(value, index) {
      return index;
    },
    rowCheckable: true,
    rowExpandable: true,
    childrenKey: 'children',
    indent: 32,
    minColWidth: 40,
    animation: true,
    showIndeterminate: true
  };
};
var events = {
  clickRow: true,
  dragstart: true,
  dragend: true,
  checkRow: true,
  uncheckRow: true,
  checkAll: true,
  uncheckAll: true,
  page: true
};
export var Table = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Table, _Component);
  function Table() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    // use public for unit test to get paginationRef
    _this.pagination = usePagination();
    _this.tree = useTree(_this.pagination.data);
    _this.columns = useColumns();
    _this.scroll = useScroll();
    _this.stickyHeader = useStickyHeader(_this.scroll.callbacks);
    _this.width = useWidth(_this.scroll.scrollRef, _this.columns.getColumns);
    _this.resizable = useResizable(_this.scroll.scrollRef, _this.width.tableRef, _this.width.tableWidth, _this.width.widthMap, _this.width.storeWidth);
    _this.fixedColumns = useFixedColumns(_this.columns.getColumns, _this.scroll, _this.width.widthMap);
    _this.disableRow = useDisableRow(_this.tree.loopData, _this.pagination.data);
    _this.merge = useMerge(_this.columns.getCols, _this.pagination.data);
    _this.checked = useChecked(_this.disableRow.getEnableKeys, _this.disableRow.getAllKeys, _this.disableRow.isDisabledKey, _this.merge.getGrid, _this.tree.loopData, _this.pagination.data);
    _this.sortable = useSortable();
    _this.expandable = useExpandable();
    _this.selected = useSelected();
    _this.resetRowStatus = useResetRowStatus(_this.disableRow.getAllKeys);
    _this.draggable = useDraggable(_this.pagination.data);
    _this.stickyScrollbar = useStickyScrollbar(_this.stickyHeader.elementRef, _this.scroll, _this.width.tableRef, _this.fixedColumns.setScrollPosition);
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Table.prototype;
  _proto.checkAll = function checkAll() {
    this.checked.toggleCheckedAll(true);
  };
  _proto.uncheckAll = function uncheckAll() {
    this.checked.toggleCheckedAll(false);
  };
  _proto.getCheckedData = function getCheckedData() {
    return this.getData('checkedKeys');
  };
  _proto.getSelectedData = function getSelectedData() {
    return this.getData('selectedKeys');
  };
  _proto.scrollToRowByIndex = function scrollToRowByIndex(index) {
    return this.scrollToRowByKey(this.disableRow.getEnableKeys()[index]);
  };
  _proto.scrollToRowByKey = function scrollToRowByKey(key) {
    var _this2 = this;
    return new _Promise(function (resolve) {
      var scrollElement = _this2.scroll.scrollRef.value;
      var tr = scrollElement.querySelector("tr[data-key=\"" + key + "\"]");
      if (!tr) return resolve();
      // we can not use scrollIntoView with smooth, because it can only operate one element
      // at the same time
      // elem.scrollIntoView({behavior: 'smooth'});
      var headerHeight = scrollElement.querySelector('thead').offsetHeight;
      var scrollTop = scrollElement.scrollTop;
      var offsetTop = tr.offsetTop - headerHeight;
      var top = offsetTop - scrollTop;
      var topOneFrame = top / 60 / (100 / 1000);
      var step = function step() {
        scrollTop = Math[topOneFrame < 0 ? 'max' : 'min'](scrollTop + topOneFrame, offsetTop);
        scrollElement.scrollTop = scrollTop;
        if (!_this2.$unmounted && scrollTop !== offsetTop) {
          requestAnimationFrame(step);
        } else {
          resolve();
        }
      };
      requestAnimationFrame(step);
    });
  };
  _proto.exportTable = /*#__PURE__*/function () {
    var _exportTable2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, filename) {
      return _regeneratorRuntime.wrap(function _callee$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (data === void 0) {
              data = this.get('data');
            }
            if (filename === void 0) {
              filename = 'table';
            }
            _context2.next = 4;
            return _exportTable(this.columns.getData, data, filename, this, filename);
          case 4:
            return _context2.abrupt("return", _context2.sent);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee, this);
    }));
    function exportTable(_x, _x2) {
      return _exportTable2.apply(this, arguments);
    }
    return exportTable;
  }();
  _proto.getData = function getData(type) {
    var keys = this.get(type);
    var ret = [];
    if (!keys) return ret;
    var allKeys = this.disableRow.getAllKeys();
    var checkedKeysMap = {};
    keys.forEach(function (item) {
      checkedKeysMap[item] = true;
    });
    this.tree.loopData(function (value, index) {
      var key = allKeys[index];
      if (checkedKeysMap[key]) {
        ret.push(value);
      }
    });
    return ret;
  };
  _proto.clickRow = function clickRow(data, index, key) {
    this.trigger('clickRow', data, index, key);
  };
  _proto.onChangeGroup = function onChangeGroup(key, value) {
    this.set("group." + key, value);
  };
  return Table;
}(Component);
Table.template = template;
Table.typeDefs = typeDefs;
Table.defaults = defaults;
Table.events = events;
__decorate([bind], Table.prototype, "clickRow", null);
__decorate([bind], Table.prototype, "onChangeGroup", null);